export default __webpack_public_path__ + "static/media/Group.3d32ad03.svg";